import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://user-images.githubusercontent.com/83460816/184789013-8b7475ac-3db4-4232-ac74-0f7f0ba9e230.png"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "AI MAKER", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "title_container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
  }, _hoisted_3))
}